import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./button.css.ts.vanilla.css-mistica.js";
var f = "1.5px", y = {
    default: "104px",
    small: "80px"
}, r = {
    default: "calc(16px - 1.5px)",
    small: "calc(12px - 1.5px)"
}, _ = {
    default: "calc(12px - 1.5px)",
    small: "calc(6px - 1.5px)"
}, a = {
    primary: "rrbrpnm rrbrpn3 _1y2v1nf7d _1y2v1nf8m _1y2v1nf9v _1y2v1nfb4 _1y2v1nfho _1y2v1nfhe _1y2v1nfi8 _1y2v1nfk9 _1y2v1nfkl _1y2v1nf2c _1y2v1nf4l",
    secondary: "rrbrpnn rrbrpn3 _1y2v1nf7d _1y2v1nf8m _1y2v1nf9v _1y2v1nfb4 _1y2v1nfho _1y2v1nfhe _1y2v1nfi8 _1y2v1nfk9 _1y2v1nfkl _1y2v1nf2f _1y2v1nf7c",
    danger: "rrbrpno rrbrpn3 _1y2v1nf7d _1y2v1nf8m _1y2v1nf9v _1y2v1nfb4 _1y2v1nfho _1y2v1nfhe _1y2v1nfi8 _1y2v1nfk9 _1y2v1nfkl _1y2v1nf2c _1y2v1nf4d",
    link: "rrbrpnp rrbrpn3 _1y2v1nf7d _1y2v1nf8m _1y2v1nf9v _1y2v1nfb4 _1y2v1nfho _1y2v1nfhe _1y2v1nfi8 _1y2v1nfk9 _1y2v1nfkl _1y2v1nf2j _1y2v1nf7c",
    linkDanger: "rrbrpnq rrbrpn3 _1y2v1nf7d _1y2v1nf8m _1y2v1nf9v _1y2v1nfb4 _1y2v1nfho _1y2v1nfhe _1y2v1nfi8 _1y2v1nfk9 _1y2v1nfkl _1y2v1nf2l _1y2v1nf7c",
    linkDangerDark: "rrbrpnr rrbrpn3 _1y2v1nf7d _1y2v1nf8m _1y2v1nf9v _1y2v1nfb4 _1y2v1nfho _1y2v1nfhe _1y2v1nfi8 _1y2v1nfk9 _1y2v1nfkl _1y2v1nf2l _1y2v1nf7c"
}, l = {
    minWidth: "var(--rrbrpn0)"
}, p = "2px", b = "8px", i = {
    default: "1.500rem",
    small: "1.250rem"
}, e = {
    primary: "rrbrpns rrbrpn3 _1y2v1nf7d _1y2v1nf8m _1y2v1nf9v _1y2v1nfb4 _1y2v1nfho _1y2v1nfhe _1y2v1nfi8 _1y2v1nfk9 _1y2v1nfkl _1y2v1nf2d _1y2v1nf4m",
    secondary: "rrbrpnt rrbrpn3 _1y2v1nf7d _1y2v1nf8m _1y2v1nf9v _1y2v1nfb4 _1y2v1nfho _1y2v1nfhe _1y2v1nfi8 _1y2v1nfk9 _1y2v1nfkl _1y2v1nf2h _1y2v1nf7c",
    danger: "rrbrpnu rrbrpn3 _1y2v1nf7d _1y2v1nf8m _1y2v1nf9v _1y2v1nfb4 _1y2v1nfho _1y2v1nfhe _1y2v1nfi8 _1y2v1nfk9 _1y2v1nfkl _1y2v1nf2c _1y2v1nf4d",
    link: "rrbrpnv rrbrpn3 _1y2v1nf7d _1y2v1nf8m _1y2v1nf9v _1y2v1nfb4 _1y2v1nfho _1y2v1nfhe _1y2v1nfi8 _1y2v1nfk9 _1y2v1nfkl _1y2v1nf2k _1y2v1nf7c",
    linkDanger: "rrbrpnw rrbrpn3 _1y2v1nf7d _1y2v1nf8m _1y2v1nf9v _1y2v1nfb4 _1y2v1nfho _1y2v1nfhe _1y2v1nfi8 _1y2v1nfk9 _1y2v1nfkl _1y2v1nf2l _1y2v1nf4h",
    linkDangerDark: "rrbrpnx rrbrpn3 _1y2v1nf7d _1y2v1nf8m _1y2v1nf9v _1y2v1nfb4 _1y2v1nfho _1y2v1nfhe _1y2v1nfi8 _1y2v1nfk9 _1y2v1nfkl _1y2v1nf2l _1y2v1nf7c"
}, h = "rrbrpn1", k = {
    default: "40px",
    small: "40px"
}, d = "rrbrpn9 _1y2v1nfhl _1y2v1nfhf _1y2v1nfkr _1y2v1nfm0 _1y2v1nfht _1y2v1nfhz", t = "rrbrpn7 _1y2v1nfhm _1y2v1nfip _1y2v1nfkl", m = "rrbrpn4", o = "rrbrpn5", c = {
    default: "1.250rem",
    small: "1.000rem"
}, x = "rrbrpnb _1y2v1nfhk _1y2v1nfhz _1y2v1nfht";
export { f as borderSize, y as buttonMinWidth, r as buttonPaddingX, _ as buttonPaddingY, a as buttonVariants, l as buttonVars, p as chevronMarginLeft, b as iconMargin, i as iconSize, e as inverseButtonVariants, h as isLoading, k as linkMinWidth, d as loadingContent, t as loadingFiller, m as small, o as smallLink, c as spinnerSize, x as textContent };
